import React, { createRef } from "react";
import BaseFileManagement from "../../../../../commonComponents/fileManagementFields/baseFileManagement";
import { ModalWithComponent } from "../../../../../../base/basicComponents/modal";
import styles from "./index.module.scss";
import ReviseProcedureFileTable from "../../procedureFileTableFields/reviseProcedureFileTable";
import AppSetting from "../../../../../../config/AppSetting";
import ProcedureDetailService from "../../../../../../service/procedureFile/ProcedureDetailService";
import downloadIcon from "../../../../../../assets/image/downloadIcon.png";
import shareIcon from "../../../../../../assets/image/detailShare.png";
import reasonEditDefaultIcon from "../../../../../../assets/image/reasonEditIcon.png";
import {
  fileTags,
  getTimeZoneString,
  handleAlertUploadFileError,
  handleUploadErrorCode,
} from "../../../../../publicDictionaryValues";
import NormalSpin from "../../../../../../base/basicComponents/spin";
const procedureReplaceFileRef = createRef();
const procedureReturnAddFileRef = createRef();
export default class ReviseProcedureFileManagement extends BaseFileManagement {
  constructor(props: any) {
    super(props);
    this.state = {
      modalState: {
        isModalWithComponentOpen: false,
        closable: false,
        okText: "Confirm",
        cancelText: "Cancel",
        modalTitle: "",
        modalLabel: "",
        handleOk: null,
        handleCancel: null,
        isOkBtnDisabled: false,
        isCancelBtnDisabled: false,
        maskClosable: false,
        isShowTextArea: false,
        textAreaPlacement: "",
        textAreaMaxLength: 0,
        textAreaClassName: "",
        rowIndex: 0,
        fileIds: [],
        fileNames: [],
        modalWidth: 520,
      },
      deleteData: [],
      downloadFileDisabled: true,
      downloadIcon: downloadIcon,
      shareIcon: shareIcon,
      loading: false,
      initOrLastSaveData: this.props.initProcedureDataList,
    };
    // @ts-ignore
    this.replaceList = [];
    // @ts-ignore
    this.fileList = [];
    // @ts-ignore
    this.deleteList = [];
    // @ts-ignore
    this.uploadProcedureFileNum = 0;
    // @ts-ignore
    this.procedureFileNum = 0;
    // @ts-ignore
    this.user = this.appSetting.localStorageValue.user.get();
  }

  componentDidMount() {
    if (this.props.fileTableRef !== undefined && this.props.fileTableRef.current !== null) {
      this.props.fileTableRef.current.updateDataList(this.props.data);
      this.setInitSaveSubmitData(this.props.data);
    }
  }

  /**
   * function about control row's checkbox when check table header checkbox
   * @param {*} ele table header checkbox element
   */
  _headOnCheck = (ele: any) => {
    const dataList: any[] = this.props.fileTableRef.current.state.data;
    if (ele.checked) {
      for (let index = 0; index < dataList.length; index++) {
        dataList[index] = { ...dataList[index], checked: true };
        const tagValue = this.handleGetDataEle(index, "fileName", "tagValue");
        const status = this.handleGetDataEle(index, "status", "value");
      }
    } else {
      for (let index = 0; index < dataList.length; index++) {
        dataList[index] = { ...dataList[index], checked: false };
      }
    }
    this.openOrDisableDeleteButton(dataList);
    this.props.fileTableRef.current.updateDataList(dataList);
  };

  handleReviseProcedureFileManagementLineIdValue = (dataList: any, currentRowIndex: any) => {
    return dataList[currentRowIndex].data.find((item: any) => item.name === "lineId").value;
  };

  handleReviseProcedureFileManagementExistsInB = (lineIdValue: any, initOrLastSaveData: any) => {
    return initOrLastSaveData.some((objB: any) => {
      const lineIdBValue = objB.data.find((item: any) => item.name === "lineId").value;
      return lineIdBValue === lineIdValue;
    });
  };

  handleReviseProcedureFileManagementDeleteFile = (dataList: any, currentRowIndex: any) => {
    const fileId = dataList[currentRowIndex].data.find((x: any) => x.name === "fileId").value;
    let dto = {
      ProductKey: AppSetting.urlPrefix.deleteFile.ProductKey,
      StorageFileID: fileId,
    };
    ProcedureDetailService.deleteFile(
      dto,
      this._deleteFileOnSuccess,
      this._deleteFileOnFail,
      fileId
    );
  };

  handleReviseProcedureFileManagementSetDataListAfterDelete = (
    dataList: any,
    currentRowIndex: any
  ) => {
    dataList.splice(currentRowIndex, 1);
    this.props.fileTableRef.current.updateDataList(dataList);
    this.setState({
      modalState: {
        ...this.state.modalState,
        isModalWithComponentOpen: false,
        modalLabel: "",
        handleOk: null,
        handleCancel: null,
      },
      // @ts-ignore
      deleteData: this.deleteList,
    });
  };

  /**
   * function about click confim when click delete each row
   * @param {*} currentRowIndex current row index
   */
  handleReviseProcedureFileManagementRowFileDeleteModalConfirm = (currentRowIndex: any) => {
    const dataList = this.getDataList();
    const lineIdValue = this.handleReviseProcedureFileManagementLineIdValue(
      dataList,
      currentRowIndex
    );
    const initOrLastSaveData = this.state.initOrLastSaveData;
    const existsInB = this.handleReviseProcedureFileManagementExistsInB(
      lineIdValue,
      initOrLastSaveData
    );
    if (existsInB) {
      // @ts-ignore
      this.deleteList.push({ ...dataList[currentRowIndex], isDelete: true });
    } else {
      this.handleReviseProcedureFileManagementDeleteFile(dataList, currentRowIndex);
    }
    this.handleReviseProcedureFileManagementSetDataListAfterDelete(dataList, currentRowIndex);
  };

  /**
   * function about hide modal
   */
  hideModal = () => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        isModalWithComponentOpen: false,
        modalLabel: "",
        handleOk: null,
        handleCancel: null,
      },
    });
  };

  /**
   * delete procedure when click each row's delete button in revise page
   * @param {*} e
   */
  deleteRowFile = (e: any) => {
    const dataList = this.getDataList();
    const index = e.target.attributes.rowindex.nodeValue;
    const isNew =
      dataList[index].data.find((item: any) => item.name === "fileName").tagValue === fileTags.new;
    const hasStatus =
      dataList[index].data.find((item: any) => item.name === "status").value !== null;
    dataList[index].data.find((item: any) => item.name === "newVersion").value = null;
    dataList[index].data.find((item: any) => item.name === "newVersion").fileId = null;

    const replaceUserId = dataList[index].data.find((item: any) => item.name === "replaceUserId");
    const replaceUserName = dataList[index].data.find(
      (item: any) => item.name === "replaceUserName"
    );
    let dataArray = [];
    if (replaceUserId && replaceUserName) {
      dataArray = dataList[index].data.filter(
        (item: any) => item.name !== "replaceUserId" && item.name !== "replaceUserName"
      );
      dataList[index].data = [...dataArray];
    }

    if (isNew && !hasStatus) {
      this.setState({
        modalState: {
          ...this.state.modalState,
          isModalWithComponentOpen: true,
          modalLabel: <span className={styles.modalText}>Are you sure to delete this file?</span>,
          handleOk: () =>
            this.handleReviseProcedureFileManagementRowFileDeleteModalConfirm(
              e.target.attributes.rowindex.nodeValue
            ),
          handleCancel: () => this.hideModal(),
        },
      });
    } else {
      dataList[index].data.find((item: any) => item.name === "fileName").tagValue =
        fileTags.deleted;
      dataList[index].isUpdate = false;
      dataList[index].isReturnDisabled = true;
      dataList[index].isApproveDisabled = false;
      if (dataList[index].isError) {
        dataList[index].isError = false;
      }
      dataList[index].data.find((item: any) => item.name === "isReviewed").value = true;
      dataList[index].data.find((item: any) => item.name === "note").isDisabled = true;
      this.props.fileTableRef.current.updateDataList(dataList);
    }
  };

  /**
   * click replace button in revise page
   * @param {*} e
   */
  replaceRowFile = (e: any) => {
    e.target.nextSibling.click();
  };

  /* rollback for procedure file table replace success */
  _replaceRowFileOnSuccess = (result: any, obj: any) => {
    this.props._hideLoading();
    const { index, fileName } = obj;
    const tableDataList = this.props.procedureRef.current.getDataList();
    tableDataList[index].data.find((item: any) => item.name === "fileName").tagValue =
      fileTags.replaced;
    tableDataList[index].data.find((item: any) => item.name === "newVersion").fileId =
      result.storageFileID;
    tableDataList[index].data.find((item: any) => item.name === "newVersion").value = fileName;
    const replaceUserId = tableDataList[index].data.find(
      (item: any) => item.name === "replaceUserId"
    );
    const replaceUserName = tableDataList[index].data.find(
      (item: any) => item.name === "replaceUserName"
    );
    if (replaceUserId && replaceUserName) {
      tableDataList[index].data.find(
        (item: any) => item.name === "replaceUserId"
        // @ts-ignore
      ).value = this.user.identityUserInfo.internalUserID;
      tableDataList[index].data.find(
        (item: any) => item.name === "replaceUserName"
        // @ts-ignore
      ).value = this.user.identityUserInfo.englishName;
    } else {
      tableDataList[index].data.push({
        name: "replaceUserId",
        // @ts-ignore
        value: this.user.identityUserInfo.internalUserID,
      });
      tableDataList[index].data.push({
        name: "replaceUserName",
        // @ts-ignore
        value: this.user.identityUserInfo.englishName,
      });
    }
    tableDataList[index].isReturnDisabled = false;
    tableDataList[index].isUpdate = true;
    if (tableDataList[index].isError) {
      tableDataList[index].isError = false;
    }
    tableDataList[index].data.find((item: any) => item.name === "isReviewed").value = true;
    tableDataList[index].data.find((item: any) => item.name === "note").isDisabled = false;
    this.props.fileTableRef.current.updateDataList(tableDataList);
  };

  /* rollback for procedure file table replace error */
  _replaceReviseProcedureFileManagementRowFileOnError = (error: any) => {
    console.log(error);
    this._alertError("Replace failed");
    this.props._hideLoading();
  };

  handleReviseProcedureFileManagementShowDuplicateModal = (tableList: any, item: any) => {
    tableList.forEach((data: any) => {
      if (
        data.data.find((i: any) => i.name === "fileName").value === item.name ||
        data.data.find((i: any) => i.name === "newVersion").value === item.name
      ) {
        this._alertError(`${item.name} already exists.`);
        // @ts-ignore
        this.isFileDuplicate = true;
      }
    });
  };

  handleReviseProcedureFileManagementRowReplaceFileAddFile = (returnPara: any, item: any) => {
    this.props._showLoading();
    let fileForm = new FormData();
    let addFileDto = this.getAddFileDto(item);
    fileForm.append("formFile", item);
    fileForm.append("addFileDto", JSON.stringify(addFileDto));
    // @ts-ignore
    ProcedureDetailService.addFile(
      fileForm,
      (response: any) => {
        this._replaceRowFileOnSuccess(response, returnPara);
      },
      this._replaceReviseProcedureFileManagementRowFileOnError
    );
  };

  /* function about procedure file table replace button */
  handleReviseProcedureFileManagementRowReplaceFileSelect = (event: any, index: any) => {
    // @ts-ignore
    this.isFileDuplicate = false;
    const files = [...event.target.files];
    const tableData = this.getDataList();
    const tableList = [...tableData];
    tableList.splice(index, 1);
    for (let item of files) {
      this.handleReviseProcedureFileManagementShowDuplicateModal(tableList, item);
      if (handleAlertUploadFileError(files)) {
        return;
      }
      const returnPara = { index: index, fileName: item.name };
      // @ts-ignore
      if (!this.isFileDuplicate) {
        this.handleReviseProcedureFileManagementRowReplaceFileAddFile(returnPara, item);
      } else {
        return;
      }
    }
  };

  /**
   * Check File Duplicate
   * @param {*} index
   * @param {*} dataList
   * @param {*} tableDataList
   * @returns
   */
  // @ts-ignore
  fileCheck = (index: any, dataList: any, tableDataList: any) => {
    // @ts-ignore
    this.uploadFileIndex = index;
    // @ts-ignore
    this.uploadDataList = dataList;
    // @ts-ignore
    this.tableDataList = tableDataList;
    const isDuplicateWithNewVersion =
      // @ts-ignore
      this.fileList[index] !== undefined &&
      tableDataList.findIndex(
        (item: any) =>
          item.data.find((dataItem: any) => dataItem.name === "newVersion").value ===
          // @ts-ignore
          this.fileList[index].name
      ) !== -1;

    // @ts-ignore
    if (index >= this.fileList.length) {
      // @ts-ignore
      if (this.replaceList.length) {
        // @ts-ignore
        this.handleReplaceModalConfirm(this.replaceList);
        // @ts-ignore
        this.replaceList = [];
      }
      return true;
    }
    if (
      dataList.findIndex(
        // @ts-ignore
        (dataItem: any) => dataItem.value === this.fileList[index].name
      ) !== -1 ||
      isDuplicateWithNewVersion
    ) {
      // @ts-ignore
      this._alertError(`${this.fileList[index].name} already exists.`);
      return false;
    } else {
      return this.fileCheck(index + 1, dataList, tableDataList);
    }
  };

  /* function about add data in table when upload files */
  createLine = (dataList: any, fileId: any, fileName: any) => {
    const lineId = this._generateGUID();
    const fileKey = this._generateGUID();
    const newFileItme = {
      data: [
        { name: "lineId", value: lineId },
        { name: "fileId", value: fileId },
        { name: "procedureFileID", value: null },
        {
          name: "procedureFileStepID",
          value: null,
        },
        { name: "fileKey", value: fileKey },
        {
          name: "fileName",
          value: fileName,
          tagValue: fileTags.new,
        },
        {
          name: "uploadedDate",
          value: this._formateDate(getTimeZoneString(this._getDate())),
        },
        // @ts-ignore
        { name: "uploadByName", value: this.user.identityUserInfo.englishName },
        {
          name: "uploadById",
          // @ts-ignore
          value: this.user.identityUserInfo.internalUserID,
        },
        { name: "note", value: null, isDisabled: false },
        { name: "status", value: null },
        {
          name: "returnReason",
          value: null,
          isDisabled: true,
          isShowReasonLog: false,
        },
        {
          name: "attachment",
          value: null,
          isDisabled: false,
          link: null,
          fileId: null,
        },
        { name: "newVersion", value: null, link: null, fileId: null },
        {
          name: "previousStatus",
          value: null,
        },
        {
          name: "previousFileTag",
          value: null,
        },
        {
          name: "isReviewed",
          value: false,
        },
      ],
      checked: false,
      isApproveDisabled: false,
      isReturnDisabled: false,
      isReturned: false,
      isError: false,
      replaceRef: procedureReplaceFileRef,
      attachmentEditIcon: reasonEditDefaultIcon,
      isDelete: false,
      isUpdate: false,
    };
    dataList.unshift(newFileItme);
    this.props.handleChangeTableErrorStatus(false);
  };

  /* function about show loading when upload file */
  handleUploadLoadiing = async () => {
    // @ts-ignore
    this.uploadProcedureFileNum += 1;
    await this.props.updateProcedureFileNum(
      // @ts-ignore
      this.procedureFileNum,
      // @ts-ignore
      this.uploadProcedureFileNum
    );
    // @ts-ignore
    if (this.uploadProcedureFileNum === this.procedureFileNum) {
      // @ts-ignore
      this.uploadProcedureFileNum = 0;
      // @ts-ignore
      this.procedureFileNum = 0;
      await this.props.updateProcedureFileNum(0, 0);
      this.props._hideLoading();
    }
  };

  /**
   * callback about upload file api success
   * @param {*} result
   * @param {*} preRequestData
   */
  _uploadProcedureFileOnSuccess = (result: any, preRequestData: any) => {
    this.props.handleChangeTableErrorStatus(false);
    handleUploadErrorCode(result.errorCode);
    const procedureFileData = this.getDataList();
    this.createLine(procedureFileData, result.storageFileID, preRequestData.fileName);
    if (preRequestData.fileList.length > 0) {
      this.handleFileSelect(preRequestData.fileList);
    }
    this.props.fileTableRef.current.updateDataList(procedureFileData);
    this.handleUploadLoadiing();
  };

  /* callback about upload file api failed */
  _uploadProcedureFileOnError = () => {
    this.handleUploadLoadiing();
  };

  handleChangeUploadTip = async () => {
    await this.props.updateProcedureFileNum(
      // @ts-ignore
      this.procedureFileNum,
      // @ts-ignore
      this.uploadProcedureFileNum
    );
  };

  /* function about upload file */
  handleFileSelect = (files: any) => {
    if (files.length === 0) {
      return;
    } else {
      // @ts-ignore
      if (handleAlertUploadFileError(this.fileList)) {
        return;
      }
      const item = files.splice(0, 1)[0];
      this.handleChangeUploadTip();
      let fileForm = new FormData();
      let addFileDto = this.getAddFileDto(item);
      fileForm.append("formFile", item);
      fileForm.append("addFileDto", JSON.stringify(addFileDto));
      ProcedureDetailService.addFile(
        fileForm,
        this._uploadProcedureFileOnSuccess,
        this._uploadProcedureFileOnError,
        { fileName: item.name, fileList: files }
      );
    }
  };

  /* function about upload deuplicate file */
  FileProcess = (index: any, dataList: any, tableDataList: any) => {
    if (!this.fileCheck(index, dataList, tableDataList)) {
      return;
    }
    // @ts-ignore
    this.handleFileSelect(this.fileList);
  };

  /* function about upload depulicate file when upload file */
  handleReplaceFile = (event: any) => {
    // @ts-ignore
    this.fileList = [...event.target.files];
    // @ts-ignore
    this.procedureFileNum = this.fileList.length;
    // @ts-ignore
    if (handleAlertUploadFileError(this.fileList)) {
      return;
    }
    const tableDataList = this.getDataList();
    let dataList: any[] = [];
    tableDataList.forEach((data: any) => {
      const item = data.data.find((dataItem: any) => dataItem.name === "fileName");
      dataList.push(item);
    });

    this.FileProcess(0, dataList, tableDataList);
  };

  /* control confirm button disabled in the modal */
  _openModalBtnsDisabled = () => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        isOkBtnDisabled: true,
        isCancelBtnDisabled: true,
      },
    });
  };

  /* control cancel button disabled in the modal */
  _hideModalBtnsDisabled = () => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        isOkBtnDisabled: false,
        isCancelBtnDisabled: false,
      },
    });
  };

  downloadFile = () => {
    this._showDownloadLoading();
    this.baseDownloadFiles(this.downloadDetailFilesSuccessfully);
  };

  handleReturnColumns = () => {
    const { isDisableAll, noteRef, status, noteDisabled, reasonRef } = this.props;
    return [
      {
        name: "ProcedureId",
        dataName: "procedureId",
        type: "text",
        isShow: false,
      },
      {
        name: "checkbox",
        dataName: "checkbox",
        type: "checkbox",
        isShow: true,
        check: this._check,
        onCheck: this._onCheck,
        headCheck: this._headCheck,
        headOnCheck: this._headOnCheck,
      },
      {
        name: "File Name",
        dataName: "fileName",
        type: "fileName",
        isShow: true,
        isDisabled: isDisableAll,
      },
      {
        name: "Uploaded Date",
        dataName: "uploadedDate",
        type: "text",
        isShow: true,
      },
      {
        name: "Uploaded By",
        dataName: "uploadByName",
        type: "text",
        isShow: true,
      },
      {
        name: "Note",
        dataName: "note",
        type: "input",
        ref: noteRef,
        isShow: status !== 3 && !this.props.isCopyPage,
        isDisabled: isDisableAll || noteDisabled,
      },
      {
        name: "Approval Date",
        dataName: "approveDate",
        type: "text",
        isShow: status === 3 || this.props.isCopyPage,
      },
      {
        name: "Status",
        dataName: "status",
        type: "tag",
        isShow: !this.props.isCopyPage,
      },
      {
        name: "Return Reason",
        dataName: "returnReason",
        type: "input",
        ref: reasonRef,
        isShow: !this.props.isCopyPage,
        showEdit: false,
        isDisabled: isDisableAll,
      },
      {
        name: "Attachment",
        dataName: "attachment",
        type: "link",
        isShow: !this.props.isCopyPage,
        showEdit: false,
      },
      {
        name: "New Version",
        dataName: "newVersion",
        type: "link",
        isShow: !this.props.isCopyPage,
      },
      {
        name: "Action",
        dataName: "action",
        type: "button",
        isApproveDisabled: false,
        isReturnDisabled: false,
        approveText: "Replace",
        returnText: "Delete",
        approveColor: "blue",
        returnColor: "greyRed",
        onApproveClick: this.replaceRowFile,
        onReturnClick: () => this.deleteRowFile,
        isShow: !isDisableAll && !this.props.isCopyPage,
      },
    ];
  };

  handleReturnFileTable = (obj: any) => {
    const {
      fileTableRef,
      columns,
      className,
      currentRole,
      downloadFile,
      isDisableAll,
      initProcedureTableData,
      setIsTableChange,
      cancelIsTableChange,
      fileTableStatus,
      optionList,
      isTableBorderError,
      isFileTableShow,
    } = obj;

    return (
      <div className={`${isTableBorderError ? styles.border_error : ""}`}>
        <ReviseProcedureFileTable
          ref={fileTableRef}
          columns={columns}
          procedureNoteMaxLength={1000}
          procedureNoteSize="small"
          inputOnChange={this.inputOnChange}
          fileTableRef={fileTableRef}
          className={className}
          currentRole={currentRole}
          downloadFile={downloadFile}
          isComplete={isDisableAll}
          initProcedureTableData={initProcedureTableData}
          isTableBorderError={isTableBorderError}
          setIsTableChange={setIsTableChange}
          cancelIsTableChange={cancelIsTableChange}
          fileTableStatus={fileTableStatus}
          handleFileSelect={this.handleReviseProcedureFileManagementRowReplaceFileSelect}
          optionList={optionList}
          isFileTableShow={isFileTableShow}
        />
      </div>
    );
  };

  handleReviseProcedureFileManagementModalWithComponent = () => {
    const {
      modalTitle,
      closable,
      isCancelBtnDisabled,
      isModalWithComponentOpen,
      modalLabel,
      rowIndex,
      fileIds,
      okText,
      cancelText,
      fileNames,
      modalWidth,
      handleOk,
      handleCancel,
      maskClosable,
      isOkBtnDisabled,
    } = this.state.modalState;

    return (
      <ModalWithComponent
        isModalOpen={isModalWithComponentOpen}
        closable={closable}
        okText={okText}
        fileIds={fileIds}
        fileNames={fileNames}
        handleOk={handleOk}
        handleCancel={handleCancel}
        isOkDisabled={isOkBtnDisabled}
        isCancelDisabled={isCancelBtnDisabled}
        maskClosable={maskClosable}
        rowindex={rowIndex}
        hideLoading={this._hideModalBtnsDisabled}
        label={modalLabel}
        fileUploadRef={procedureReplaceFileRef}
        fileUploadInputRef={procedureReturnAddFileRef}
        openLoading={this._openModalBtnsDisabled}
        isLoading={isOkBtnDisabled}
        modalWidth={modalWidth}
        cancelText={cancelText}
        title={modalTitle}
      />
    );
  };

  render() {
    const {
      noteRef,
      reasonRef,
      currentRole,
      isDisableAll,
      status,
      noteDisabled,
      fileTableRef,
      className,
      downloadFile,
      initProcedureTableData,
      fileTableStatus,
      optionList,
      setIsTableChange,
      cancelIsTableChange,
      isShow = true,
    } = this.props;

    // @ts-ignore
    const columns = this.handleReturnColumns({
      isDisableAll,
      noteRef,
      status,
      noteDisabled,
      reasonRef,
    });

    return (
      <NormalSpin spinning={this.state.loading} size="large">
        <div style={{ display: isShow ? "block" : "none" }}>
          <div className={styles.fileManagementDiv}>
            <div className={styles.buttonDiv}>
              {this.handleReturnDownloadBtn(true, this.state.downloadFileDisabled)}
              {this.handleReturnShareBtn(false, this.state.downloadFileDisabled)}
              {this.handleReturnUploadBtn(!isDisableAll, false, this.handleReplaceFile)}
            </div>
            {this.handleReturnFileTable({
              fileTableRef,
              columns,
              className,
              currentRole,
              downloadFile,
              isDisableAll,
              initProcedureTableData,
              setIsTableChange,
              cancelIsTableChange,
              fileTableStatus,
              optionList,
              isTableBorderError: this.props.isTableBorderError,
              isFileTableShow: isShow,
            })}
          </div>
          {this.handleReviseProcedureFileManagementModalWithComponent()}
        </div>
      </NormalSpin>
    );
  }
}
